/* Northsilk – animates the discount progress bar and keeps it in sync with the cart */
(() => {
  if (window.nsCartOffer) return;
  window.nsCartOffer = true;

  const lastProgress = {};

  const animateFill = (fill) => {
    if (fill.dataset.nsAnimated) return;
    fill.dataset.nsAnimated = 'true';

    const context = fill.dataset.context || 'page';
    const to = parseFloat(fill.dataset.progress) || 0;
    const from = lastProgress[context];
    lastProgress[context] = to;

    if (from === undefined || from === to) return;

    fill.style.transition = 'none';
    fill.style.width = `${from}%`;
    void fill.offsetWidth;
    fill.style.transition = '';
    fill.style.width = `${to}%`;
  };

  const scan = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches('[data-ns-offer-fill]')) animateFill(node);
    node.querySelectorAll('[data-ns-offer-fill]').forEach(animateFill);
  };

  const refresh = (section) => {
    const base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(`${base}?section_id=${section.dataset.sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.getElementById('ns-cart-offer');
        const source = next && next.querySelector('.js-ns-offer');
        const target = section.querySelector('.js-ns-offer');
        if (!source || !target) return;
        target.innerHTML = source.innerHTML;
        section.classList.toggle('is-empty', next.classList.contains('is-empty'));
      })
      .catch(() => {});
  };

  const init = () => {
    document.querySelectorAll('[data-ns-offer-fill]').forEach(animateFill);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });

    const section = document.getElementById('ns-cart-offer');
    if (section && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh(section));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
